import React from 'react';
import { Helmet } from 'react-helmet-async';
import { COMPANY_NAME, ADDRESS, PHONE_NUMBER, EMAIL, GOOGLE_MAPS_LINK } from '../constants';

interface SEOProps {
  title: string;
  description: string;
  keywords?: string[];
  image?: string;
  url?: string;
  type?: string;
}

export const SEO: React.FC<SEOProps> = ({ 
  title, 
  description, 
  keywords = [], 
  image = 'https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&q=80&w=1200', 
  url = typeof window !== 'undefined' ? window.location.href : '',
  type = 'website'
}) => {
  const siteTitle = `${title} | ${COMPANY_NAME}`;
  const defaultKeywords = [
    "Event Management", 
    "Wedding Planner", 
    "Midnapore", 
    "Decorator", 
    "Catering", 
    "Corporate Events"
  ];
  const allKeywords = [...defaultKeywords, ...keywords].join(", ");

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": COMPANY_NAME,
    "image": image,
    "@id": url,
    "url": url,
    "telephone": PHONE_NUMBER,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": ADDRESS,
      "addressLocality": "Midnapore",
      "addressRegion": "West Bengal",
      "postalCode": "721101",
      "addressCountry": "IN"
    },
    "email": EMAIL,
    "sameAs": [
      GOOGLE_MAPS_LINK
    ]
  };

  return (
    <Helmet>
      {/* Standard Metadata */}
      <title>{siteTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={allKeywords} />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={siteTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};